import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useAuth } from '../contexts/SupabaseAuthContext';
import { requestPortalAfterLogin } from '../lib/stripePortal';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const LandingMenu = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // La dashboard apre il portale Stripe appena la famiglia è caricata
  const openAbbonamento = () => {
    requestPortalAfterLogin();
    navigate(user ? '/dashboard' : '/login');
  };

  const items = [
    { id: 'blog', label: 'Blog', onSelect: () => navigate('/blog') },
    { id: 'prezzi', label: 'Prezzi', onSelect: () => scrollToSection('prezzi') },
    { id: 'come-funziona', label: 'Come funziona', onSelect: () => scrollToSection('come-funziona') },
    { id: 'abbonamento', label: 'Abbonamento', onSelect: openAbbonamento },
  ];

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Apri menu"
          data-testid="landing-menu-button"
          className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 rounded-lg border-2 border-[#3D9A5D] text-[#3D9A5D] hover:bg-[#3D9A5D] hover:text-white transition-colors"
        >
          <Menu className="w-5 h-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        onCloseAutoFocus={(e) => e.preventDefault()}
        className="w-48 rounded-xl p-1.5"
        data-testid="landing-menu"
      >
        {items.map((item) => (
          <DropdownMenuItem
            key={item.id}
            onSelect={item.onSelect}
            data-testid={`landing-menu-${item.id}`}
            className="cursor-pointer rounded-lg px-3 py-2.5 text-base font-medium text-[#2C3E50] focus:bg-[#F0F7F2] focus:text-[#1B5E3A]"
          >
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
